import Component from 'can/component/component';
import template from './live-video-drawer.stache';

const DRAWER_TYPES = {
    GROUP: 'GROUP',
    HOLES: 'HOLES',
};

Component.extend({
    tag: 'live-video-drawer',
    template: template,
    leakScope: false,
    viewModel: {
        define: {
            type: {
                type: 'string',
                value: DRAWER_TYPES.GROUP,
            },
            DRAWER_TYPES: {
                type: 'object',
                value: DRAWER_TYPES,
            },
            cards: {
                type: 'object',
                value: {},
            },
            activeView: {
                type: 'object',
                value: {},
            },
            data: {
                type: 'object',
                value: null,
            },
            channelName: {
                type: 'string',
                value: '',
            },
        },
    },
    events: {
        inserted() {
            this.setDrawer(
                this.getCurrentChannel({
                    activeView: this.viewModel.attr('activeView'),
                    cards: this.viewModel.attr('cards'),
                }),
            );

            const channelCompute = can.compute(() => ({
                activeView: this.viewModel.attr('activeView'),
                cards: this.viewModel.attr('cards'),
            }));

            channelCompute.bind('change', (_, value) => {
                this.viewModel.attr('fetching', true);
                const currentChannel = this.getCurrentChannel(value);

                this.setDrawer(currentChannel);
                this.viewModel.attr('fetching', false);
            });
        },

        getCurrentChannel({ activeView, cards }) {
            const activeViewId = activeView.attr('videos.0');

            if (!activeViewId) {
                return;
            }

            //TODO: investigate implementation with lodash
            const currentChannel = cards
                .filter((it) => it.attr('video.identifier') === activeViewId)
                .attr(0);

            return currentChannel;
        },

        setDrawer(channel) {
            if (!channel) {
                return;
            }

            if (
                channel.attr('channelIdentifier') &&
                channel.attr('channelIdentifier').includes('featured-group') &&
                channel.attr('playerTagGroups')
            ) {
                this.viewModel.attr('type', DRAWER_TYPES.GROUP);
                this.viewModel.attr('data', channel.attr('playerTagGroups.0'));
                this.viewModel.attr('channelName', channel.attr('title'));
            } else if (
                channel.attr('channelIdentifier') &&
                channel.attr('channelIdentifier').includes('featured-hole') &&
                channel.attr('holeTags')
            ) {
                this.viewModel.attr('type', DRAWER_TYPES.HOLES);
                this.viewModel.attr('data', channel.attr('holeTags'));
            }
        },
    },
});
